import type { ReactNode } from "react";
import { Link } from "wouter";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

/** Wspólne klasy przycisków paska akcji w stopce sidebara (ikona 18px w polu 36px). */
export const SIDEBAR_FOOTER_ACTION_CLASS =
  "w-9 h-9 rounded-lg flex items-center justify-center text-white/45 bg-white/[0.04] hover:bg-white/[0.09] transition-colors";

/** Ciemny tooltip spójny z DropdownMenu w sidebarze (np. LanguageSwitcher). */
export const SIDEBAR_TOOLTIP_CLASS =
  "bg-[#0a0a0f] border-white/10 text-white/90 px-2.5 py-1.5 text-xs font-normal";

type Props = {
  label: string;
  icon: ReactNode;
  /** Kolor ikony po najechaniu, np. `hover:text-[#ef3e29]`. */
  hoverClassName?: string;
  /** Nawigacja przez wouter `<Link>` — zachowuje semantykę linku (nowa karta, itp.). */
  href?: string;
  onClick?: () => void;
};

export function SidebarFooterAction({
  label,
  icon,
  hoverClassName = "hover:text-white",
  href,
  onClick,
}: Props) {
  const className = `${SIDEBAR_FOOTER_ACTION_CLASS} ${hoverClassName}`;
  const trigger = href ? (
    <Link href={href} className={className} aria-label={label}>
      {icon}
    </Link>
  ) : (
    <button type="button" onClick={onClick} className={className} aria-label={label}>
      {icon}
    </button>
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>{trigger}</TooltipTrigger>
      <TooltipContent side="top" className={SIDEBAR_TOOLTIP_CLASS}>
        {label}
      </TooltipContent>
    </Tooltip>
  );
}
